export function levenshtein(a: string, b: string): number {
    const al = a.toLowerCase();
    const bl = b.toLowerCase();
    const matrix: number[][] = [];
    for (let i = 0; i <= al.length; i++) matrix[i] = [i];
    for (let j = 0; j <= bl.length; j++) matrix[0][j] = j;
    for (let i = 1; i <= al.length; i++) {
        for (let j = 1; j <= bl.length; j++) {
            const cost = al[i - 1] === bl[j - 1] ? 0 : 1;
            matrix[i][j] = Math.min(
                matrix[i - 1][j] + 1,
                matrix[i][j - 1] + 1,
                matrix[i - 1][j - 1] + cost,
            );
        }
    }
    return matrix[al.length][bl.length];
}

export interface ContactMatchCandidate {
    id: number;
    email?: string | null;
    first_name: string;
    last_name: string;
    company_name: string;
}

export interface IncomingContact {
    email?: string;
    first_name: string;
    last_name: string;
    company_name: string;
}

export function findDuplicateContact(
    incoming: IncomingContact,
    existing: ContactMatchCandidate[],
): ContactMatchCandidate | null {
    // Primary: exact email match
    if (incoming.email) {
        const emailMatch = existing.find(
            (e) => e.email && e.email.toLowerCase() === incoming.email!.toLowerCase(),
        );
        if (emailMatch) return emailMatch;
    }

    // Secondary: name + fuzzy company (Levenshtein <= 2)
    for (const candidate of existing) {
        const nameMatch =
            candidate.first_name.toLowerCase() === incoming.first_name.toLowerCase() &&
            candidate.last_name.toLowerCase() === incoming.last_name.toLowerCase();
        if (nameMatch && levenshtein(candidate.company_name, incoming.company_name) <= 2) {
            return candidate;
        }
    }

    return null;
}
